import { FiX } from "react-icons/fi";
import { FeedbackForm } from "./FeedbackForm";
import { DueDiligenceFeedbackQuestionsConfig } from "../../Common/Hooks/useApi/Schemas";
import { BottomBanner, BannerCard, CloseButton, FormTitle } from "./Styles";

interface FeedbackPromptProps {
  config: DueDiligenceFeedbackQuestionsConfig;
  isSubmitting: boolean;
  onSubmit: (data: { npsScore: number; answers: Record<string, string> }) => void;
  onDismiss: () => void;
}

// Copy here is intentionally generic (product-level, not case-specific): this
// is every client user's very first encounter with feedback, and it should
// read as "tell us about the platform", not "tell us about this DD" — even
// though the submission is internally tied to whichever case is open.
export const FeedbackPrompt = ({ config, isSubmitting, onSubmit, onDismiss }: FeedbackPromptProps) => {
  return (
    <BottomBanner>
      <BannerCard>
        <CloseButton onClick={onDismiss} aria-label="Cerrar">
          <FiX size={18} />
        </CloseButton>
        <FormTitle>¿Qué tal tu experiencia con la plataforma?</FormTitle>
        <FeedbackForm config={config} isSubmitting={isSubmitting} onSubmit={onSubmit} />
      </BannerCard>
    </BottomBanner>
  );
};
